import React from 'react';
import { Button } from 'lib/@mui';
import { Add } from 'lib/@mui/Icons';

export const AddButton = ({ title, onClick }) => (
    <Button
        size="large"
        variant="contained"
        color="primary"
        className="addButton"
        onClick={onClick}
        startIcon={<Add />}
    >
        {title}
    </Button>
);
